<app-policies-style [documentData]="documentData"></app-policies-style>